import type { ReactTable, RowData, TableFeatures } from "@tanstack/react-table";
import type { Pagination } from "./datatable";
import type { CommonFeatures } from "@/hooks/useTanstackTable";
import { Paginator } from "./Paginator";

interface TableFooterProps<TF extends TableFeatures, TD extends RowData> {
	readonly table: ReactTable<TF, TD>;
	readonly pagination: Pagination;
	readonly setPagination: Setter<Pagination>;
}
export function TableFooter<TF extends CommonFeatures, TD extends RowData>(props: TableFooterProps<TF, TD>) {
	const { pagination, setPagination } = props;
	const table = props.table as unknown as ReactTable<CommonFeatures, TD>;
	const itemCount = table.getFilteredRowModel().rows.length;

	return (
		<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
			<div>
				Mostrando {pagination.pageIndex * pagination.pageSize + 1} a {Math.min((pagination.pageIndex + 1) * pagination.pageSize, itemCount)} de {itemCount} artículos
			</div>

			<Paginator
				pageCount={table.getPageCount()}
				pageIndex={table.state.pagination.pageIndex}
				shownPages={5}
				onPageChange={newPageIndex => { setPagination(old => ({ ...old, pageIndex: newPageIndex })); }}
				canPrevious={table.getCanPreviousPage()}
				canNext={table.getCanNextPage()}
			/>
		</div>
	);
}